import { useParams } from "react-router-dom";

import { Container, useMediaQuery, Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useEffect } from "react";
import _cookies from "../../../shared/utils/_cookies";
import NavigationPage from "../../../ui/templates/NavigationPage";

function carregarDashboardPost(username, pesquisaId) {
  var form = document.createElement("form");
  form.method = "POST";
  form.action = `${window.location.origin}/DASHBOARD_PESQUISA.aspx`;
  form.target = "dashboardFrame";
  form.style.display = "none";
  var inputUsername = document.createElement("input");
  inputUsername.type = "hidden";
  inputUsername.name = "USERNAME";
  inputUsername.value = btoa(username);
  form.appendChild(inputUsername);
  var inputPesquisaId = document.createElement("input");
  inputPesquisaId.type = "hidden";
  inputPesquisaId.name = "PESQUISAID";
  inputPesquisaId.value = btoa(pesquisaId.toString());
  form.appendChild(inputPesquisaId);
  document.body.appendChild(form);
  form.submit();
  setTimeout(() => document.body.removeChild(form), 100);
}

export default function SurveyDashboard() {
  const { surveyId } = useParams();

  const theme = useTheme();
  const breakString = theme.breakpoints.down("md");
  const isDisplaySmall = useMediaQuery(breakString);
  useEffect(() => {
    carregarDashboardPost(
      _cookies.getItem("auth").user?.username.toLocaleUpperCase(),
      surveyId
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <NavigationPage
        rootRoute={{ label: "Gestão de  pesquisas", route: "/pesquisagestor" }}
        themeRoute={{ label: "Estatísticas" }}
      >
        <Container
          disableGutters={isDisplaySmall}
          maxWidth="unset"
          sx={{ height: "100%" }}
        >
          <Box
            component={"iframe"}
            sx={{ width: "100%", height: "100%" }}
            iframe
            id="dashboardFrame"
            name="dashboardFrame"
          />
        </Container>
      </NavigationPage>
    </>
  );
}
